import { AbilityBuilder, createMongoAbility } from '@casl/ability'
import { AppAbility } from './types'
import { Roles } from './roles'
import { User } from 'modules/User/useCurrentUser'


export function defineAbilityForRole(user: User) {
  const { can, cannot, build } = new AbilityBuilder<AppAbility>(createMongoAbility)
  const role = user.role?.role_id
  const isExternal = user.is_external
  // const allowedZones = user.allowedZoneIds ?? []

  if (isExternal) {
    cannot('access', 'GlobalHub')
  } else {
    can('access', 'GlobalHub')
  }

  if (role === Roles.Viewer) {
    // Story
    can('read', 'Story')

    // Project
    can('read', 'Project')
    can('read', 'GlobalProject')

  } else if (role === Roles.Author) {
    // Story
    can(['create', 'read', 'edit', 'delete'], 'Story')

    // Project
    can('read', 'Project')
    can('read', 'GlobalProject')

  } else if (role === Roles.LocalProjectOwner) {
    // Story
    can(['create', 'read', 'edit', 'delete'], 'Story')
    cannot(['edit', 'delete'], 'Story', { global_status: 'PUBLISHED' })

    // Project
    can(['create', 'read', 'edit', 'delete'], 'Project')
    can(['read', 'localize'], 'GlobalProject')

  } else if (role === Roles.GlobalProjectOwner) {
    // Story
    can(['create', 'read', 'edit', 'delete', 'globalize'], 'Story')

    // Global Story
    can('manage', 'GlobalStory')

    // Project
    can(['create', 'read', 'edit', 'delete', 'globalize'], 'Project')
    can(['read', 'edit', 'delete','localize'], 'GlobalProject')

  } else if (role === Roles.ZoneManager) {
    // Story
    can(['create', 'read', 'edit', 'delete', 'globalize'], 'Story')

    // Global Story
    can('manage', 'GlobalStory')

    // Project
    can(['create', 'read', 'edit', 'delete', 'globalize'], 'Project')
    can(['read', 'edit', 'delete','localize'], 'GlobalProject')
    can('manage', 'Zone', { id: user.label_id })
    cannot('create', 'Zone')

    can('access', 'AdminPanel')

  } else if (role === Roles.GlobalManager || role === Roles.Admin) {
    // Story
    can(['create', 'read', 'edit', 'delete', 'globalize'], 'Story')

    // Global Story
    can('manage', 'GlobalStory')

    // Project
    can(['create', 'read', 'edit', 'delete', 'globalize'], 'Project', { label_id: user.label_id })
    can(['read', 'edit', 'delete','localize'], 'GlobalProject')
    can('manage', 'Zone')

    can('access', 'AdminPanel')
  }

  return build()
}


